import { createAction } from 'redux-actions';

export const INJECT_NAVIGATE = 'crdf.navigation.injectNavigate';
export const NAVIGATE = 'crdf.navigation.navigate';
export const NOOP = 'crdf.navigation.noop';

export const injectNavigate = createAction(INJECT_NAVIGATE);
export const navigate = createAction(NAVIGATE);
export const noop = createAction(NOOP);
